import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Button from 'components/ui/button';
import { cdnURL } from 'components/utils/cdn';
import Picture from 'components/ui/picture';

import './styles.scss';

const RemindersPromo = ({ className }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  const onImageLoaded = () => {
    setTimeout(() => {
      setImageLoaded(true);
    }, 100);
  }

  const onClick = () => {
    navigate('/reminders/birthday/add');
  }

  return (
    <div className={`reminders-promo-container ${className}`}>
      <h2 className="promo-title">Remembering birthdays for 20+ years</h2>
      <p className="promo-text">Over 50,000,000 users have counted on Birthday Alarm to be their birthday reminder service. We love to help people celebrate!</p>
      <div className={`image-container ${imageLoaded ? 'animate' : ''}`}>
        <Picture
          src={cdnURL('img/rebuild/promote/homepage/reminders-promo.png')}
          has2x
          hasWebp
          alt="Add Reminders"
          onLoaded={onImageLoaded}
          width={1015}
          height={157}
        />
      </div>
      <Button onClick={onClick}>Create a reminder</Button>
    </div>
  );
}


RemindersPromo.propTypes = {
  className: PropTypes.string,
};

RemindersPromo.defaultProps = {
  className: ''
};

export default RemindersPromo;
